export default __webpack_public_path__ + "static/media/platinum0.42e82f8f.svg";